export default {"src":"/_next/static/media/plus-icon.b81a9132.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};